export default "__VITE_ASSET__CbHbqm34__"